import * as THREE from 'three';

/**
 * Create an inner sash frame (4 box strips) for an operable section.
 * Origin at bottom-left of the section opening.
 */
export function createSash(
  sectionWidth: number,
  sectionHeight: number,
  sashWidth: number,
  sashDepth: number,
  material: THREE.Material,
): THREE.Group {
  const group = new THREE.Group();
  group.name = 'sash';

  const hw = sashWidth / 2;

  // Bottom rail
  const bottomGeo = new THREE.BoxGeometry(sectionWidth, sashWidth, sashDepth);
  const bottom = new THREE.Mesh(bottomGeo, material);
  bottom.position.set(sectionWidth / 2, hw, 0);
  bottom.castShadow = true;
  group.add(bottom);

  // Top rail
  const topGeo = new THREE.BoxGeometry(sectionWidth, sashWidth, sashDepth);
  const top = new THREE.Mesh(topGeo, material);
  top.position.set(sectionWidth / 2, sectionHeight - hw, 0);
  top.castShadow = true;
  group.add(top);

  // Left stile
  const leftGeo = new THREE.BoxGeometry(sashWidth, sectionHeight - 2 * sashWidth, sashDepth);
  const left = new THREE.Mesh(leftGeo, material);
  left.position.set(hw, sectionHeight / 2, 0);
  left.castShadow = true;
  group.add(left);

  // Right stile
  const rightGeo = new THREE.BoxGeometry(sashWidth, sectionHeight - 2 * sashWidth, sashDepth);
  const right = new THREE.Mesh(rightGeo, material);
  right.position.set(sectionWidth - hw, sectionHeight / 2, 0);
  right.castShadow = true;
  group.add(right);

  return group;
}
